import React from 'react';
import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material';
import { Routes, Route } from 'react-router-dom';
import { BrowserRouter } from "react-router-dom";
import { HomePage } from './Pages/Homepage';
import { AboutPage } from './Pages/AboutPage';
import { UsesPage } from './Pages/UsesPage';
import { NavPage } from './Pages/NavPage';

const theme = responsiveFontSizes(createTheme({
    palette: {
        primary: {
            main: '#2563eb',
        },
        text: {
            primary: '#1e293b',
            secondary: '#64748b',
        },
        background: {
            default: '#fafafa',
        },
    },
    typography: {
        allVariants: {
            fontFamily: ['Inter', '-apple-system', 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Oxygen',
                'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', 'sans-serif'].join(',')
        },
        h4: {
            fontWeight: 700,
            letterSpacing: '-0.02em',
        },
        h5: {
            fontWeight: 600,
            letterSpacing: '-0.01em',
        },
        h6: {
            fontWeight: 600,
        },
        subtitle1: {
            lineHeight: 1.75,
            color: '#475569',
        },
        button: {
            textTransform: 'none'
        }
    },
    components: {
        MuiLink: {
            styleOverrides: {
                root: {
                    color: '#2563eb',
                    textDecorationColor: 'rgba(37, 99, 235, 0.4)',
                    transition: 'color 0.2s ease, text-decoration-color 0.2s ease',
                    '&:hover': {
                        color: '#1d4ed8',
                        textDecorationColor: '#1d4ed8',
                    },
                },
            },
        },
    },
}));

function App() {
    return (
        <ThemeProvider theme={theme}>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<HomePage />}>
                        <Route index element={<AboutPage />} />
                        <Route path="uses" element={<UsesPage />} />
                    </Route>
                    <Route path="/nav" element={<NavPage />} />
                </Routes>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
